import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import FullLogo from '../assets/logos/full-logo.png'
import CirclesBg from '../assets/svgs/not-found-circles.svg'
import theme from '../constants/theme'
import {
  FooterContent,
  PageWrapper,
  BgCircles,
  ContentArea,
  SearchCircle,
  PageTitle,
  PageDescription,
} from './styled'
import PrimaryButton from './buttons/PrimaryButton'
import CheckOne from '../assets/svgs/checkOne'
import ExclamationCircle from '../assets/svgs/exclamationCircle'
import Frown from '../assets/svgs/frown'
import useDeviceType from '../hooks/useDeviceType'

const TYPE_TITLE = {
  success: "You're All Set!",
  error: 'Something Went Wrong',
  warning: 'Heads Up!',
}

function NotificationBoxPage({
  messageType,
  message,
  rescheduleInterview,
  rescheduleEnabled,
  isFinished,
  isExpired,
  children,
}) {
  const { t } = useTranslation()
  const deviceType = useDeviceType()
  const isMobile = deviceType !== 'desktop'

  const iconSize = isMobile ? '36px' : '48px'

  let messageIcon = <CheckOne width={iconSize} height={iconSize} />
  let messageColor = theme.talentinoGreen

  switch (messageType) {
    case 'success':
      messageIcon = <CheckOne width={iconSize} height={iconSize} />
      messageColor = theme.talentinoGreen
      break
    case 'error':
      messageIcon = <Frown width={iconSize} height={iconSize} />
      messageColor = theme.talentinoDarkerRed
      break
    case 'warning':
      messageIcon = (
        <ExclamationCircle
          width={iconSize}
          height={iconSize}
          color={theme.talentinoWarning}
        />
      )
      messageColor = theme.talentinoWarning
      break
    default:
      messageIcon = <CheckOne width={iconSize} height={iconSize} />
      messageColor = theme.talentinoBlue
      break
  }

  return (
    <PageWrapper>
      <div className="p-3 ps-4">
        <img height="auto" width="130" src={FullLogo} alt="Talentino" />
      </div>

      <BgCircles>
        <img src={CirclesBg} alt="" aria-hidden="true" className="w-100" />
      </BgCircles>

      <ContentArea>
        <SearchCircle
          style={{ marginBottom: '1.5rem', borderColor: `${messageColor}30` }}
        >
          {messageIcon}
        </SearchCircle>

        <PageTitle>{TYPE_TITLE[messageType] || TYPE_TITLE.error}</PageTitle>

        {message && <PageDescription>{message}</PageDescription>}

        {rescheduleEnabled && !isFinished && isExpired && (
          <PrimaryButton
            color={theme.talentinoSpecialBlue}
            backgroundcolor={theme.talentinoWhiteBlue}
            hovercolor={theme.talentinoDarkerWhiteBlue}
            onClick={rescheduleInterview}
            style={{
              fontSize: isMobile ? '14px' : '16px',
              padding: isMobile ? '5px 15px' : '5px 40px',
              marginTop: '12px',
            }}
          >
            {t('preInterview.rescheduleInterview')}
          </PrimaryButton>
        )}

        {children}
      </ContentArea>

      <FooterContent className="fixed-bottom text-center text-gray-100 py-2 border-t border-gray-200">
        {t('footer.TalentinoAI')} © {new Date().getFullYear()}{' '}
        {t('footer.allRightsReserved')}
      </FooterContent>
    </PageWrapper>
  )
}

export default NotificationBoxPage

NotificationBoxPage.propTypes = {
  messageType: PropTypes.string,
  message: PropTypes.string,
  rescheduleInterview: PropTypes.func,
  rescheduleEnabled: PropTypes.bool,
  isFinished: PropTypes.bool,
  isExpired: PropTypes.bool,
  children: PropTypes.node,
}

NotificationBoxPage.defaultProps = {
  messageType: 'error',
  message: '',
  rescheduleInterview: () => {},
  rescheduleEnabled: false,
  isFinished: false,
  isExpired: false,
  children: null,
}
